import { createReducer } from 'reduxsauce';
import { isEqual, cloneDeep, filter } from 'lodash';

import { StatsCompanyTypes } from '../actions/stats-company.actions';
import { COMMISSION_TYPES } from '../../constants/app.constants';

const initialState = {
  status: [],
  usersActivityLevel: { driving_total: 0, driving: [] },
  usersInfractions: { infractions_total: 0, infractions: [] },
  userInfractions: {},
  missedOpportunities: [],
  totalMissedRepossessions: 0,
  missedRepossessions: {},
  totalSpottedVehicles: 0,
  spottedVehicles: {},
  totalRepossessions: 0,
  repossessions: {},
  hoursWorked: {},
  totalCommissions: 0,
  individualCommissions: {},
  teamCommissions: {},
  perVehicleCommissions: {},
  customCommissions: {},
};

const getActivityLevelRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-activity-level');

  return {
    ...state,
    usersActivityLevel: initialState.usersActivityLevel,
    status,
  };
};
const getActivityLevelSuccess = (state, action) => {
  const usersActivityLevel = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-activity-level', a));

  return { ...state, usersActivityLevel, status };
};
const getActivityLevelFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-activity-level', a));

  return { ...state, status };
};

const getInfractionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-infractions');

  return {
    ...state,
    usersInfractions: initialState.usersInfractions,
    status,
  };
};
const getInfractionsSuccess = (state, action) => {
  const usersInfractions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-infractions', a));

  return { ...state, usersInfractions, status };
};
const getInfractionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-infractions', a));

  return { ...state, status };
};

const getUserInfractionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-user-infractions');

  return { ...state, userInfractions: initialState.userInfractions, status };
};
const getUserInfractionsSuccess = (state, action) => {
  const userInfractions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-user-infractions', a));

  return { ...state, userInfractions, status };
};
const getUserInfractionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-user-infractions', a));

  return { ...state, status };
};

const getTotalMissedRepossessionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-total-missed-repossessions');

  return { ...state, totalMissedRepossessions: 0, status };
};
const getTotalMissedRepossessionsSuccess = (state, action) => {
  const totalMissedRepossessions = action.response.total || 0;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-missed-repossessions', a));

  return { ...state, totalMissedRepossessions, status };
};
const getTotalMissedRepossessionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-missed-repossessions', a));

  return { ...state, status };
};

const getMissedRepossessionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-missed-repossessions');

  return { ...state, missedRepossessions: {}, status };
};
const getMissedRepossessionsSuccess = (state, action) => {
  const missedRepossessions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-missed-repossessions', a));

  return { ...state, missedRepossessions, status };
};
const getMissedRepossessionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-missed-repossessions', a));

  return { ...state, status };
};

const getTotalSpottedVehiclesRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-total-spotted-vehicles');

  return { ...state, totalSpottedVehicles: 0, status };
};
const getTotalSpottedVehiclesSuccess = (state, action) => {
  const totalSpottedVehicles = action.response.total || 0;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-spotted-vehicles', a));

  return { ...state, totalSpottedVehicles, status };
};
const getTotalSpottedVehiclesFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-spotted-vehicles', a));

  return { ...state, status };
};

const getSpottedVehiclesRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-spotted-vehicles');

  return { ...state, spottedVehicles: {}, status };
};
const getSpottedVehiclesSuccess = (state, action) => {
  const spottedVehicles = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-spotted-vehicles', a));

  return { ...state, spottedVehicles, status };
};
const getSpottedVehiclesFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-spotted-vehicles', a));

  return { ...state, status };
};

const getTotalRepossessionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-total-repossessions');

  return { ...state, totalRepossessions: 0, status };
};
const getTotalRepossessionsSuccess = (state, action) => {
  const totalRepossessions = action.response.total || 0;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-repossessions', a));

  return { ...state, totalRepossessions, status };
};
const getTotalRepossessionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-repossessions', a));

  return { ...state, status };
};

const getRepossessionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-repossessions');

  return { ...state, repossessions: {}, status };
};
const getRepossessionsSuccess = (state, action) => {
  const repossessions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-repossessions', a));

  return { ...state, repossessions, status };
};
const getRepossessionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-repossessions', a));

  return { ...state, status };
};

const getHoursWorkedRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-hours-worked');

  return { ...state, hoursWorked: {}, status };
};
const getHoursWorkedSuccess = (state, action) => {
  const hoursWorked = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-hours-worked', a));

  return { ...state, hoursWorked, status };
};
const getHoursWorkedFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-hours-worked', a));

  return { ...state, status };
};

const getTotalCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-total-commissions');

  return { ...state, totalCommissions: 0, status };
};
const getTotalCommissionsSuccess = (state, action) => {
  const totalCommissions = action.response.total || 0;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-commissions', a));

  return { ...state, totalCommissions, status };
};
const getTotalCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-total-commissions', a));

  return { ...state, status };
};

const getCommissionsRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-get-commissions-${action.commissionType}`);

  return { ...state, status };
};
const getCommissionsSuccess = (state, action) => {
  const commissions = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-get-commissions-${action.commissionType}`, a));

  if (action.commissionType === COMMISSION_TYPES.individual) {
    return { ...state, individualCommissions: commissions, status };
  }
  if (action.commissionType === COMMISSION_TYPES.team) {
    return { ...state, teamCommissions: commissions, status };
  }
  if (action.commissionType === COMMISSION_TYPES.per_vehicle) {
    return { ...state, perVehicleCommissions: commissions, status };
  }
  if (action.commissionType === COMMISSION_TYPES.custom) {
    return { ...state, customCommissions: commissions, status };
  }
  return { ...state, status };
};
const getCommissionsFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-get-commissions-${action.commissionType}`, a));

  return { ...state, status };
};

const clearStatsRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [StatsCompanyTypes.GET_ACTIVITY_LEVEL_REQUEST]: getActivityLevelRequest,
  [StatsCompanyTypes.GET_ACTIVITY_LEVEL_SUCCESS]: getActivityLevelSuccess,
  [StatsCompanyTypes.GET_ACTIVITY_LEVEL_FAILURE]: getActivityLevelFailure,

  [StatsCompanyTypes.GET_INFRACTIONS_REQUEST]: getInfractionsRequest,
  [StatsCompanyTypes.GET_INFRACTIONS_SUCCESS]: getInfractionsSuccess,
  [StatsCompanyTypes.GET_INFRACTIONS_FAILURE]: getInfractionsFailure,

  [StatsCompanyTypes.GET_USER_INFRACTIONS_REQUEST]: getUserInfractionsRequest,
  [StatsCompanyTypes.GET_USER_INFRACTIONS_SUCCESS]: getUserInfractionsSuccess,
  [StatsCompanyTypes.GET_USER_INFRACTIONS_FAILURE]: getUserInfractionsFailure,

  [StatsCompanyTypes.GET_TOTAL_SPOTTED_VEHICLES_REQUEST]: getTotalSpottedVehiclesRequest,
  [StatsCompanyTypes.GET_TOTAL_SPOTTED_VEHICLES_SUCCESS]: getTotalSpottedVehiclesSuccess,
  [StatsCompanyTypes.GET_TOTAL_SPOTTED_VEHICLES_FAILURE]: getTotalSpottedVehiclesFailure,

  [StatsCompanyTypes.GET_SPOTTED_VEHICLES_REQUEST]: getSpottedVehiclesRequest,
  [StatsCompanyTypes.GET_SPOTTED_VEHICLES_SUCCESS]: getSpottedVehiclesSuccess,
  [StatsCompanyTypes.GET_SPOTTED_VEHICLES_FAILURE]: getSpottedVehiclesFailure,

  [StatsCompanyTypes.GET_TOTAL_MISSED_REPOSSESSIONS_REQUEST]: getTotalMissedRepossessionsRequest,
  [StatsCompanyTypes.GET_TOTAL_MISSED_REPOSSESSIONS_SUCCESS]: getTotalMissedRepossessionsSuccess,
  [StatsCompanyTypes.GET_TOTAL_MISSED_REPOSSESSIONS_FAILURE]: getTotalMissedRepossessionsFailure,

  [StatsCompanyTypes.GET_MISSED_REPOSSESSIONS_REQUEST]: getMissedRepossessionsRequest,
  [StatsCompanyTypes.GET_MISSED_REPOSSESSIONS_SUCCESS]: getMissedRepossessionsSuccess,
  [StatsCompanyTypes.GET_MISSED_REPOSSESSIONS_FAILURE]: getMissedRepossessionsFailure,

  [StatsCompanyTypes.GET_TOTAL_REPOSSESSIONS_REQUEST]: getTotalRepossessionsRequest,
  [StatsCompanyTypes.GET_TOTAL_REPOSSESSIONS_SUCCESS]: getTotalRepossessionsSuccess,
  [StatsCompanyTypes.GET_TOTAL_REPOSSESSIONS_FAILURE]: getTotalRepossessionsFailure,

  [StatsCompanyTypes.GET_REPOSSESSIONS_REQUEST]: getRepossessionsRequest,
  [StatsCompanyTypes.GET_REPOSSESSIONS_SUCCESS]: getRepossessionsSuccess,
  [StatsCompanyTypes.GET_REPOSSESSIONS_FAILURE]: getRepossessionsFailure,

  [StatsCompanyTypes.GET_HOURS_WORKED_REQUEST]: getHoursWorkedRequest,
  [StatsCompanyTypes.GET_HOURS_WORKED_SUCCESS]: getHoursWorkedSuccess,
  [StatsCompanyTypes.GET_HOURS_WORKED_FAILURE]: getHoursWorkedFailure,

  [StatsCompanyTypes.GET_TOTAL_COMMISSIONS_REQUEST]: getTotalCommissionsRequest,
  [StatsCompanyTypes.GET_TOTAL_COMMISSIONS_SUCCESS]: getTotalCommissionsSuccess,
  [StatsCompanyTypes.GET_TOTAL_COMMISSIONS_FAILURE]: getTotalCommissionsFailure,

  [StatsCompanyTypes.GET_COMMISSIONS_REQUEST]: getCommissionsRequest,
  [StatsCompanyTypes.GET_COMMISSIONS_SUCCESS]: getCommissionsSuccess,
  [StatsCompanyTypes.GET_COMMISSIONS_FAILURE]: getCommissionsFailure,

  [StatsCompanyTypes.CLEAR_STATS_REQUEST]: clearStatsRequest,
});
